import { render, staticRenderFns } from "./safety-stocks-modal.vue?vue&type=template&id=48ebd780&"
import script from "./safety-stocks-modal.vue?vue&type=script&lang=js&"
export * from "./safety-stocks-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports